module.exports = __webpack_public_path__ + "img/vib2.ccad47f7.png";